/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import * as ModalActionCreators from '@app/actions/ModalActionCreators';
import {modal} from '@app/actions/ModalActionCreators';
import {Nagbar} from '@app/components/layout/Nagbar';
import {NagbarButton} from '@app/components/layout/NagbarButton';
import {NagbarContent} from '@app/components/layout/NagbarContent';
import {UserSettingsModal} from '@app/components/modals/UserSettingsModal';
import UserStore from '@app/stores/UserStore';
import {Trans} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

export const EmailVerificationNagbar = observer(({isMobile}: {isMobile: boolean}) => {
	const user = UserStore.currentUser;
	if (!user) {
		return null;
	}

	const daysElapsed = Math.floor((Date.now() - user.createdAt.getTime()) / (1000 * 60 * 60 * 24));
	const daysRemaining = Math.max(0, 30 - daysElapsed);

	const openUserSettings = () => {
		ModalActionCreators.push(modal(() => <UserSettingsModal initialTab="account_security" />));
	};

	return (
		<Nagbar isMobile={isMobile} backgroundColor="#ea580c" textColor="#ffffff">
			<NagbarContent
				isMobile={isMobile}
				message={
					daysRemaining > 0 ? (
						<Trans>
							Hey {user.displayName}, you have {daysRemaining} days left to verify your email address.
						</Trans>
					) : (
						<Trans>Hey {user.displayName}, your email verification deadline has passed. Please verify now.</Trans>
					)
				}
				actions={
					<NagbarButton isMobile={isMobile} onClick={openUserSettings}>
						<Trans>Verify Email</Trans>
					</NagbarButton>
				}
			/>
		</Nagbar>
	);
});
